import { useEffect, type ReactNode } from 'react';

import {
  clearSession,
  currentAccessToken,
  renewSession,
  useSessionStore,
} from '@shared/session/session.store';
import { configureApiClient } from '@shared/api/api-client';

/**
 * Conecta el cliente HTTP con la sesion.
 *
 * El registro ocurre en el modulo -no dentro del componente- para que ya este
 * hecho antes de que cualquier consulta se dispare. Hacerlo en un efecto
 * dejaria una ventana en la que las primeras peticiones saldrian sin token.
 *
 * Es tambien la razon de que el cliente reciba estas funciones por registro en
 * lugar de importar el store: `shared/` no puede depender de una feature sin
 * romper la arquitectura, y esa regla la verifica el linter.
 */
configureApiClient({
  tokenProvider: currentAccessToken,
  unauthorizedHandler: clearSession,
  sessionRefresher: renewSession,
});

/**
 * Recupera la sesion al arrancar.
 *
 * La aplicacion no guarda el access token en disco -vive solo en memoria, para
 * que ningun script pueda leerlo-, asi que al recargar la pagina se pierde. Lo
 * que sobrevive es la cookie `httpOnly`, y este intento es el que la canjea
 * por una sesion nueva sin pedir la contrasena otra vez.
 */
export function SessionProvider({ children }: { children: ReactNode }) {
  const restore = useSessionStore((state) => state.restore);

  useEffect(() => {
    void restore();
  }, [restore]);

  return children;
}
